import { useNavigate } from 'react-router-dom'
import { EmptyBarChart } from '../chart/EmptyBarChart'
import {
  CouponToolitip,
  CouponToolitip2,
  FreeCouponToolitip,
  PercentyCouponToolitip,
} from 'pages/content-video-editor/components/shortvideo/CouponToolitip'
import { useEffect, useState } from 'react'
import {
  LongVideoMonthlyDonutChart,
  LongVideoMonthlyMobileDonutChart,
} from '../chart/\bLongVideoMonthlyDonutChart'
import { LongVideoDailyBarChart } from '../chart/DailyBarChart'
import { LongVideoMonthlyBarChart } from '../chart/LongVideoMonthlyBarChart copy'
import { useCountdown, UserType } from '../../utils/common'
import { isMobile } from 'react-device-detect'
import classNames from 'classnames'
import useGetUsageMonthly from '../../hooks/query/plans/useGetUsageMonthly'
import useGetUsageAnnual from '../../hooks/query/plans/useGetUsageAnnual'
import { useLuckyDraw } from '../../hooks/query/point/useLuckyDraw'
import CountUp from 'react-countup'
import useUsageStore from '../../store/useUsageStore'

export const LightPlan = (props: any) => {
  const {
    subscriptionType,
    startDate,
    endDate,
    currentMonth,
    subscriptions,
    monthStart,
    monthEnd,
  } = props

  const [couponTooltipStatus, setCouponTooltipStatus] = useState(false)
  const navigate = useNavigate()
  const pDate = new Date(
    subscriptionType === 'annual' ? monthEnd : endDate + ' 23:59:59',
  )

  // 카운트다운을 조건별로 진행

  const { formattedTime } = useCountdown(pDate, true)
  const moveToPriceGuide = () => {
    navigate('/price-guide')
  }
  return (
    <>
      <div className="relative flex w-[315px] flex-col items-center justify-evenly gap-2 rounded-[10px] bg-white p-5 md:w-[325px]">
        <p className="flex w-full items-center text-left font-bold">
          <img
            src="assets/img/check_circle.png"
            alt="check_circle"
            width={15}
            height={15}
            className="mr-2"
          />
          <div>
            <span className="text-main">
              {subscriptions?.planName}{' '}
              {subscriptionType === 'annual'
                ? '1년'
                : subscriptionType === 'monthly'
                  ? `${subscriptions?.subscriptionTypeLabel}`
                  : ''}
            </span>{' '}
            {` `}
            <span> 사용중</span>
          </div>
        </p>
        <p className="w-full text-left text-[14px]">
          <span className="font-bold">
            {' '}
            {subscriptionType === 'annual'
              ? `${currentMonth}`
              : subscriptionType === 'monthly'
                ? '기간'
                : ''}
          </span>{' '}
          <span className="text-[#B6BBC6]">
            {' '}
            {subscriptionType === 'annual' ? (
              <>
                {' '}
                {monthStart} ~ {monthEnd}
              </>
            ) : (
              <>
                {' '}
                {startDate} ~ {endDate}
              </>
            )}
          </span>
        </p>

        {subscriptionType === 'annual' ? (
          <>
            {' '}
            <EmptyBarChart
              barCount={12}
              barWidth={12}
              isXAxis={false}
              chartHeight={100}
            />
            <button
              className="d:w-[215px] absolute left-4 top-[50%] z-40 flex h-[33px] w-[275px] items-center justify-center rounded-[40px] bg-[#E8FDFD] text-center text-[12px] font-bold md:left-5 md:h-[30px]"
              onClick={moveToPriceGuide}
            >
              <p>
                {' '}
                플랜 업그레이드 하고{' '}
                <span className="text-main"> 럭키드로우 참여 {`>`}</span>
              </p>
            </button>
          </>
        ) : (
          <>
            {' '}
            <EmptyBarChart
              barCount={30}
              barWidth={4}
              isXAxis={true}
              chartHeight={80}
            />
            <button
              className="absolute left-4 top-[57.5%] z-40 flex h-[33px] w-[275px] items-center justify-center rounded-[40px] bg-[#E8FDFD] text-center text-[12px] font-bold md:left-14 md:h-[30px] md:w-[215px]"
              onClick={moveToPriceGuide}
            >
              <p>
                {' '}
                플랜 업그레이드 하고{' '}
                <span className="text-main"> 럭키드로우 참여 {`>`}</span>
              </p>
            </button>
          </>
        )}
      </div>
      <div className="flex w-full items-center justify-between gap-2 rounded-[10px] bg-white p-[10px] md:p-5">
        <div
          className="relative flex h-[135px] w-[147px] cursor-pointer flex-col items-center justify-center gap-2 rounded-[16px] bg-[#E8FDFD] py-[11px]"
          onClick={moveToPriceGuide}
        >
          <img
            src="assets/img/lock.png"
            alt="lock"
            width={98}
            height={98}
            className="absolute -top-8 left-5 md:left-7"
          />
          <p className="h-[45px]"></p>
          <p className="text-center text-[12px] font-bold leading-[14.32px] text-main">
            플랜 업그레이드 하고
            <br /> 럭키드로우 받으세요!
          </p>
          <button className="h-[30px] w-[127px] rounded-[40px] bg-main text-[12px] font-bold text-white">
            {' '}
            업그레이드
          </button>
        </div>
        <div className="flex w-[195px] flex-col items-end">
          <p className="mb-2 rounded-[10px] bg-[#FFF6E6] px-3 py-1 text-center text-[12px] font-bold">
            종료까지 <span className="text-error">{formattedTime}</span>
          </p>
          <p className="mb-2 text-[14px] font-bold md:text-base">
            이번 라운드 럭키드로우
          </p>
          <p
            className="mb-4 flex h-[41px] w-[145px] items-center justify-center rounded-[6px] bg-cover bg-center text-[20px] font-bold text-white"
            style={{
              backgroundImage: "url('assets/img/gray_balance.png')",
            }}
          >
            ???????
          </p>
          <p
            className="cursor-pointer text-[12px] font-bold text-[#FF8800]"
            onClick={() => {
              setCouponTooltipStatus((prev) => !prev)
            }}
          >
            {' '}
            럭키드로우 미션 자세히 보기 {`>`}
          </p>
        </div>
      </div>
      <CouponToolitip
        couponTooltipStatus={couponTooltipStatus}
        setCouponTooltipStatus={setCouponTooltipStatus}
      />
    </>
  )
}

export const ProAndPremiumPlanMonthly = (props: any) => {
  const {
    userType,
    subscriptionType,
    startDate,
    endDate,
    currentMonth,
    available,
    couponBenefit,
    isDone,
    subscriptions,
  } = props

  const { data: UsageData, isPending, refetch } = useGetUsageMonthly()

  const setRefetch = useUsageStore((state: any) => state.setRefetch)
  const [usedCount, setUsedCount] = useState(0)
  const [totalLimit, setTotalLimit] = useState(0)

  const [couponTooltipStatus, setCouponTooltipStatus] = useState(false)
  const [isSuccess, setSuccess] = useState<boolean>(false)
  const navigate = useNavigate()
  const mDate = new Date(couponBenefit?.until)
  const pDate = new Date(endDate + ' 23:59:59')

  // 카운트다운을 조건별로 진행
  const targetDate = isDone ? mDate : pDate
  const { formattedTime } = useCountdown(targetDate, true)
  const moveToPriceGuide = () => {
    navigate('/price-guide')
  }
  useEffect(() => {
    if (refetch && typeof refetch === 'function') {
      setRefetch(refetch) // refetch가 함수일 때만 설정
    }
  }, [refetch, setRefetch])

  useEffect(() => {
    if (UsageData?.usage) {
      setUsedCount(Number(UsageData.usage.usedCount))
      setTotalLimit(UsageData.usage.planLimit)
    }
  }, [UsageData])

  return (
    <>
      <div className="relative flex h-[210px] w-[315px] flex-col items-center gap-2 rounded-[10px] bg-white p-5 md:w-[325px]">
        <p className="flex w-full items-center text-left font-bold">
          <img
            src={
              userType === UserType['숏폼 스페셜']
                ? 'assets/img/check_circle_blue.png '
                : 'assets/img/check_circle.png'
            }
            alt="check_circle"
            width={15}
            height={15}
            className="mr-2"
          />
          <div>
            <span
              className={classNames('', {
                'text-main':
                  userType === UserType.프로 || userType === UserType.프리미엄,
                'text-href': userType === UserType['숏폼 스페셜'],
              })}
            >
              {userType === UserType.프로 ? '프로' : ''}
              {userType === UserType.프리미엄 ? '프리미엄' : ''}{' '}
              {userType === UserType['숏폼 스페셜'] ? '숏폼 스페셜' : ''}{' '}
              {subscriptions?.subscriptionTypeLabel}
            </span>{' '}
            {` `}
            <span> {isDone ? '사용 완료' : '사용중'}</span>
          </div>
        </p>
        <p className="w-full text-left text-[14px]">
          <span className="mr-1 font-bold"> 기간</span>{' '}
          <span className="text-[#B6BBC6]">
            {' '}
            {startDate} ~ {endDate}
          </span>
        </p>
        {UsageData?.charts && (
          <LongVideoDailyBarChart barWidth={4} chartData={UsageData?.charts} />
        )}
      </div>
      <div className="flex items-center gap-2 rounded-[10px] bg-white p-5">
        {/* 왼쪽  */}
        {isMobile ? (
          <>
            <div className="flex flex-col">
              {' '}
              <LongVideoMonthlyMobileDonutChart
                current={usedCount}
                total={totalLimit}
                color1={isDone ? '#91FFCA' : '#FFF6B7'}
                color2={isDone ? '#009FB1' : '#F6416C'}
              />
              <div className="flex flex-col items-center">
                <p className="text-[14px] font-bold">
                  <span
                    className={classNames('', {
                      'text-[#FF8800]': !isDone,
                      'text-[#00B7B9]': isDone,
                    })}
                  >
                    {usedCount}개
                  </span>
                  <span className="text-[#D4D9DF]"> / {totalLimit}개</span>
                </p>
                <p
                  className={classNames('font-bold', {
                    'text-[#FF8800]': !isDone,
                    'text-[#00B7B9]': isDone,
                  })}
                >
                  {((usedCount / totalLimit) * 100).toFixed(1)}%
                </p>
              </div>
            </div>
          </>
        ) : (
          <>
            <LongVideoMonthlyDonutChart
              current={usedCount}
              total={totalLimit}
              color1={isDone ? '#91FFCA' : '#FFF6B7'}
              color2={isDone ? '#009FB1' : '#F6416C'}
              textColor1={isDone ? '#00B7B9' : '#FF8800'}
              textColor2={'#D4D9DF'}
              textColor3={isDone ? '#00B7B9' : '#FF8800'}
            />
          </>
        )}
        {/* 오른쪽  */}
        <div className="flex w-[195px] flex-col items-end">
          {isDone ? (
            <>
              <p className="mb-2 rounded-[10px] bg-error px-2 py-1 text-center text-[12px] font-bold">
                할인 종료까지{' '}
                <span className="text-white">{formattedTime}</span>
              </p>
            </>
          ) : (
            <>
              <p className="mb-2 rounded-[10px] bg-[#FFF6E6] px-2 py-1 text-center text-[12px] font-bold">
                미션 종료까지{' '}
                <span className="text-error">{formattedTime}</span>
              </p>
            </>
          )}

          {isDone ? (
            <p
              className={classNames('mb-2 flex items-center font-bold', {
                'cursor-pointer': isDone,
              })}
              onClick={moveToPriceGuide}
            >
              <img src="assets/img/money.png" width={18} height={20} alt="" />
              <span className="text-[14px] font-bold text-main md:text-base">
                결제 보너스 받기 {`>`}
              </span>
            </p>
          ) : (
            <p className="mb-2 text-[14px] font-bold md:text-base">
              다음 라운드 결제 보너스 혜택
            </p>
          )}

          <p
            className={classNames('mb-4', {
              'cursor-pointer': isDone,
            })}
            onClick={isDone && moveToPriceGuide}
          >
            <img
              src="assets/img/coupon/5percenty.png"
              alt=""
              width={107}
              height={55.16}
            />
          </p>
          {isDone ? (
            <>
              <p
                className={classNames('text-[12px] font-bold', {
                  'cursor-pointer': isDone,
                })}
                onClick={moveToPriceGuide}
              >
                <span className="text-[#FF8800]">3일간의</span> 할인 혜택을
                받으세요!
              </p>
            </>
          ) : (
            <>
              <p className="text-[12px] font-bold">
                <span className="text-[#FF8800]">
                  {totalLimit - usedCount}개
                </span>{' '}
                더 생성하면 할인 받을 수 있어요
              </p>
              <p
                className="cursor-pointer text-[12px] font-bold text-[#FF8800]"
                onClick={() => {
                  setCouponTooltipStatus((prev) => !prev)
                }}
              >
                {' '}
                자세히 알아보기 {`>`}
              </p>
            </>
          )}
        </div>
      </div>
      {subscriptionType === 'monthly' ? (
        <PercentyCouponToolitip
          couponTooltipStatus={couponTooltipStatus}
          setCouponTooltipStatus={setCouponTooltipStatus}
          userType={userType}
        />
      ) : (
        <CouponToolitip2
          couponTooltipStatus={couponTooltipStatus}
          setCouponTooltipStatus={setCouponTooltipStatus}
        />
      )}
    </>
  )
}

export const ProAndPremiumPlanAnnual = (props: any) => {
  const {
    userType,
    subscriptionType,
    startDate,
    endDate,
    currentMonth,
    available,
    couponBenefit,
    isDone,
  } = props

  const { data: usageData, isPending, refetch } = useGetUsageAnnual()
  const { mutate, isPending: luckyDrawPending } = useLuckyDraw()
  const setRefetch = useUsageStore((state: any) => state.setRefetch)
  const [usedCount, setUsedCount] = useState(0)
  const [totalLimit, setTotalLimit] = useState(0)
  const [couponTooltipStatus, setCouponTooltipStatus] = useState(false)
  const [isSuccess, setSuccess] = useState<boolean>(false)
  const navigate = useNavigate()
  const mDate = new Date(usageData?.mission?.monthEndDate ?? '00')
  const pDate = new Date(endDate + ' 23:59:59')

  // 카운트다운을 조건별로 진행
  const targetDate = usageData?.mission?.monthEndDate ? mDate : pDate
  const { formattedTime } = useCountdown(targetDate, true)

  const moveToPriceGuide = () => {
    navigate('/price-guide')
  }
  const handleLuckyDraw = (achievementId: number) => {
    if (achievementId !== 0) {
      mutate(achievementId, {
        onSuccess: () => {
          refetch()
        },
        onError: () => {},
      })
    }
  }
  useEffect(() => {
    if (refetch && typeof refetch === 'function') {
      setRefetch(refetch) // refetch가 함수일 때만 설정
    }
  }, [refetch, setRefetch])

  useEffect(() => {
    if (usageData?.usage) {
      setUsedCount(Number(usageData.usage.usedCount))
      setTotalLimit(usageData.usage.planLimit)
    }
  }, [usageData])

  return (
    <>
      <div className="relative flex h-[210px] w-[315px] flex-col items-center gap-2 rounded-[10px] bg-white p-5 md:h-auto md:w-[325px]">
        <p className="flex w-full items-center text-left font-bold">
          <img
            src={
              userType === UserType['숏폼 스페셜']
                ? 'assets/img/check_circle_blue.png '
                : 'assets/img/check_circle.png'
            }
            alt="check_circle"
            width={15}
            height={15}
            className="mr-2"
          />
          <div>
            {userType === UserType.프로 && (
              <>
                <span className="text-main">프로 1년</span>
                <span> 사용중 </span>
              </>
            )}
            {userType === UserType.프리미엄 && (
              <>
                <span className="text-main">프리미엄 1년</span>
                <span> 사용중 </span>
              </>
            )}
            {userType === UserType['숏폼 스페셜'] && (
              <>
                <span className="text-href">상품 숏폼 스페셜 1년</span>
                <span> 사용중 </span>
              </>
            )}
            {userType === UserType.프로
              ? '프로'
              : userType === UserType.프리미엄
                ? '프리미엄'
                : ''}
            {` `}

            {` `}
          </div>
        </p>
        <p className="w-full text-left text-[14px]">
          <span className="mr-1 font-bold"> {currentMonth ?? ''}</span>{' '}
          <span className="text-[#B6BBC6]">
            {' '}
            {startDate} ~ {endDate}
          </span>
        </p>

        {usageData?.charts && (
          <LongVideoMonthlyBarChart chartData={usageData?.charts} />
        )}
      </div>
      <div className="flex items-center gap-2 rounded-[10px] bg-white p-5">
        {/* 왼쪽  */}
        {isMobile ? (
          <>
            <div className="flex flex-col">
              {' '}
              <LongVideoMonthlyMobileDonutChart
                current={usedCount}
                total={totalLimit}
                color1={usageData?.achievement ? '#91FFCA' : '#FFF6B7'}
                color2={usageData?.achievement ? '#009FB1' : '#F6416C'}
              />
              <div className="flex flex-col items-center">
                <p className="text-[14px] font-bold">
                  <span
                    className={classNames('', {
                      'text-[#FF8800]': !usageData?.achievement,
                      'text-[#00B7B9]': usageData?.achievement,
                    })}
                  >
                    {usedCount}개
                  </span>
                  <span className="text-[#D4D9DF]"> / {totalLimit}개</span>
                </p>
                <p
                  className={classNames('font-bold', {
                    'text-[#FF8800]': !usageData?.achievement,
                    'text-[#00B7B9]': usageData?.achievement,
                  })}
                >
                  {((usedCount / totalLimit) * 100).toFixed(1)}%
                </p>
              </div>
            </div>
          </>
        ) : (
          <>
            <LongVideoMonthlyDonutChart
              current={usedCount}
              total={totalLimit}
              color1={isDone ? '#91FFCA' : '#FFF6B7'}
              color2={isDone ? '#009FB1' : '#F6416C'}
              textColor1={isDone ? '#00B7B9' : '#FF8800'}
              textColor2={'#D4D9DF'}
              textColor3={isDone ? '#00B7B9' : '#FF8800'}
            />
          </>
        )}
        {/* 오른쪽  */}
        <div className="flex w-[195px] flex-col items-end">
          {usageData?.achievement && !usageData.mission.result ? (
            <>
              <p className="mb-2 rounded-[10px] bg-[#FFF6E6] px-2 py-1 text-center text-[12px] font-bold">
                미션 종료까지{' '}
                <span className="text-error">{formattedTime}</span>
              </p>
            </>
          ) : (
            !usageData?.achievement &&
            !usageData?.mission.result && (
              <>
                <p className="mb-2 rounded-[10px] bg-[#FFF6E6] px-2 py-1 text-center text-[12px] font-bold">
                  미션 종료까지{' '}
                  <span className="text-error">{formattedTime}</span>
                </p>
              </>
            )
          )}
          {usageData?.mission.result && (
            <>
              <p className="mb-2 rounded-[10px] bg-[#FFF6E6] px-2 py-1 text-center text-[12px] font-bold">
                미션 성공
              </p>
            </>
          )}
          <p className="mb-2 text-[14px] font-bold md:text-base">
            이번 라운드 럭키 드로우
          </p>

          {usageData?.mission.luckyDrawAvaliable ? (
            <p
              className="mb-4 flex h-[41px] w-[145px] cursor-pointer items-center rounded-[6px] bg-cover bg-center text-[12px] font-bold text-white"
              onClick={() => {
                handleLuckyDraw(usageData?.achievement?.id ?? 0)
              }}
              style={{
                backgroundImage: "url('assets/img/blue_balance.png')",
              }}
            >
              <span
                className="ml-[5px] flex h-[31px] w-[113px] items-center justify-center bg-cover bg-center"
                style={{
                  backgroundImage: "url('assets/img/luckydraw_bg.png')",
                }}
              >
                <span className="mr-[5px] text-[18px]"> 🎰</span> 선물 뽑기
              </span>
            </p>
          ) : (
            <p
              className="mb-4 flex h-[41px] w-[145px] items-center justify-center rounded-[6px] bg-cover bg-center text-[20px] font-bold text-white"
              style={{
                backgroundImage: "url('assets/img/blue_balance.png')",
              }}
            >
              {usageData?.mission.result ? (
                <>
                  +
                  <CountUp
                    end={Number(usageData?.mission?.pointAmount)}
                    duration={3}
                    separator=","
                  />
                </>
              ) : (
                <>???????</>
              )}
            </p>
          )}

          {usageData?.achievement ? (
            <>
              {usageData.mission.result ? (
                <>
                  <p className={classNames('text-[12px] font-bold', {})}>
                    보너스 캐시를 받으셨어요!
                  </p>{' '}
                  <p className="text-[12px] font-bold text-[#8F929B]">
                    {' '}
                    유효기간 1개월
                  </p>
                </>
              ) : (
                <>
                  <p className={classNames('text-[12px] font-bold', {})}>
                    보너스 선물을 뽑아보세요!
                  </p>
                  <p
                    className="cursor-pointer text-[12px] font-bold text-[#FF8800]"
                    onClick={() => {
                      setCouponTooltipStatus((prev) => !prev)
                    }}
                  >
                    {' '}
                    자세히 알아보기 {`>`}
                  </p>
                </>
              )}
            </>
          ) : (
            <>
              <p className="text-[12px] font-bold">
                <span className="text-[#FF8800]">
                  {totalLimit - usedCount}개
                </span>{' '}
                더 생성하면 받을 수 있어요
              </p>
              <p
                className="cursor-pointer text-[12px] font-bold text-[#FF8800]"
                onClick={() => {
                  setCouponTooltipStatus((prev) => !prev)
                }}
              >
                {' '}
                자세히 알아보기 {`>`}
              </p>
            </>
          )}
        </div>
      </div>
      <CouponToolitip2
        couponTooltipStatus={couponTooltipStatus}
        setCouponTooltipStatus={setCouponTooltipStatus}
      />
    </>
  )
}

export const EmptyPlan = (props: any) => {
  const { monthly, period, setPlanPriceModal, test } = props
  const [couponTooltipStatus, setCouponTooltipStatus] = useState(false)
  const navigate = useNavigate()
  const moveToChallenge = () => {
    navigate('/challenge')
  }
  const moveToVideo = () => {
    navigate('/video-editor')
  }

  const moveToPriceGuide = () => {
    navigate('/price-guide')
  }
  return (
    <>
      <div className="relative flex w-[315px] flex-col items-center justify-evenly gap-1 rounded-[10px] bg-white p-5 md:w-[325px]">
        <p className="flex w-full items-center text-left font-bold">
          <img
            src="assets/img/check_circle.png"
            alt="check_circle"
            width={15}
            height={15}
            className="mr-2"
          />
          <div>아직 사용 플랜이 없어요</div>
        </p>
        <p className="mb-5 w-full text-left text-[14px]">
          <span className="font-bold">기간</span>{' '}
          <span className="text-[#B6BBC6]">{'-- ~ --'}</span>
        </p>

        <EmptyBarChart
          barCount={30}
          barWidth={4}
          isXAxis={true}
          chartHeight={80}
        />
      </div>
      <div className="flex w-full items-center justify-between gap-2 rounded-[10px] bg-white p-[10px] md:p-5">
        <div className="relative flex h-[118px] w-[129px] cursor-pointer flex-col items-center justify-center rounded-[16px] bg-[#EBEEFF] md:h-[135px] md:w-[147px]">
          <img
            src="assets/img/lock_blue.png"
            alt="lock"
            className="absolute -top-7 left-4 h-[85.82px] w-[85.82px] md:-top-8 md:left-7 md:h-[98px] md:w-[98px]"
          />
          <p className="h-[45px]"></p>
          <p className="mb-[3px] text-center text-[12px] font-bold leading-[14.32px] text-[#4360EC]">
            플랜 시작 하고
            <br /> 보너스 캐시 받으세요
          </p>
          <button
            className="h-[26.3px] w-[111.33px] rounded-[40px] bg-[#4360EC] text-[12px] font-bold text-white md:h-[30px] md:w-[127px]"
            onClick={() => {
              setPlanPriceModal(true)
            }}
          >
            {' '}
            지금 시작하기
          </button>
        </div>
        <div className="flex w-[150px] flex-col items-end md:w-[195px]">
          <p className="mb-2 rounded-[10px] bg-[#FFF6E6] px-3 py-1 text-center text-[12px] font-bold">
            미션 시작 전
          </p>
          <p className="mb-1 text-[14px] font-bold md:text-base">
            이번 라운드 럭키 드로우
          </p>
          <p
            className="mb-4 flex h-[41px] w-[145px] items-center justify-center rounded-[6px] bg-cover bg-center text-[20px] font-bold text-white"
            style={{
              backgroundImage: "url('assets/img/blue_balance.png')",
            }}
          >
            ???????
          </p>

          <p
            className="cursor-pointer text-[12px] font-bold text-[#FF8800]"
            onClick={() => {
              setCouponTooltipStatus((prev) => !prev)
            }}
          >
            {' '}
            럭키드로우 미션 자세히 보기 {`>`}
          </p>
        </div>
        <CouponToolitip
          couponTooltipStatus={couponTooltipStatus}
          setCouponTooltipStatus={setCouponTooltipStatus}
        />
      </div>
    </>
  )
}

export const FreePlan = (props: any) => {
  const {
    subscriptionType,
    startDate,
    endDate,
    currentMonth,
    totalLimit,
    usedCount,
    available,
    couponBenefit,
    isDone,
  } = props
  const { data, isPending, refetch } = useGetUsageMonthly()
  const setRefetch = useUsageStore((state: any) => state.setRefetch)
  // const usageSet = useUsageStore((state: any) => state.set)
  // usageSet({ usage: data })

  const [couponTooltipStatus, setCouponTooltipStatus] = useState(false)
  const [missionDate, setMissionDate] = useState('')
  const [planDate, setPlanDate] = useState('')
  const navigate = useNavigate()
  const moveToPriceGuide = () => {
    navigate('/price-guide')
  }
  const handleTooltip = () => {
    setCouponTooltipStatus((prev) => !prev)
  }
  const moveToChallenge = () => {
    navigate('/coupon-pack')
  }

  const mDate = new Date(couponBenefit?.until)
  const pDate = new Date('20' + endDate + ' 23:59:59')

  // 카운트다운을 조건별로 진행
  const targetDate = isDone ? mDate : pDate
  const { formattedTime } = useCountdown(targetDate, true)
  useEffect(() => {
    if (refetch && typeof refetch === 'function') {
      setRefetch(refetch) // refetch가 함수일 때만 설정
    }
  }, [refetch, setRefetch])

  return (
    <>
      <div className="relative flex h-[210px] w-[315px] flex-col items-center rounded-[10px] bg-white p-5 md:h-auto md:w-[325px]">
        <p className="mb-2 flex w-full items-center text-left font-bold">
          <img
            src="assets/img/check_circle.png"
            alt="check_circle"
            width={15}
            height={15}
            className="mr-2"
          />
          <div>
            <span className="">
              체험 플랜 {available ? '사용중' : '사용 종료'}{' '}
            </span>{' '}
          </div>
        </p>
        <p className="mb-5 flex w-full flex-col items-start font-bold">
          <p className="w-full text-left text-[14px]">
            <span className="mr-1 font-bold">
              {' '}
              {subscriptionType === 'annual'
                ? `${currentMonth}라운드`
                : subscriptionType === 'monthly'
                  ? '기간'
                  : ''}
            </span>{' '}
            <span className="text-[#B6BBC6]">
              {' '}
              {startDate} ~ {endDate}
            </span>
          </p>
          <p className="flex w-full text-left text-[14px] font-bold">
            <span className="mr-1 font-bold">현황</span>{' '}
            <p className="flex">
              <span className="text-main">요청 {usedCount}개</span>

              <span className="text-[#B6BBC6]"> / </span>
              <span className="text-[#B6BBC6]">{totalLimit}개</span>
            </p>
          </p>
        </p>

        {data?.charts && (
          <LongVideoDailyBarChart chartData={data.charts} barWidth={4} />
        )}
      </div>
      <div className="flex w-auto items-center justify-between gap-2 rounded-[10px] bg-white p-[10px] md:p-5">
        <div
          className="relative flex h-[118px] w-[129px] cursor-pointer flex-col items-center justify-center rounded-[16px] bg-[#EBEEFF] md:h-[135px] md:w-[147px]"
          onClick={moveToPriceGuide}
        >
          <img
            src="assets/img/lock_blue.png"
            alt="lock"
            className="absolute -top-7 left-4 h-[85.82px] w-[85.82px] md:-top-8 md:left-7 md:h-[98px] md:w-[98px]"
          />
          <p className="h-[45px]"></p>
          <p className="mb-[3px] text-center text-[12px] font-bold leading-[14.32px] text-[#4360EC]">
            플랜 시작 하고
            <br /> 보너스 캐시 받으세요
          </p>
          <button
            className="h-[26.3px] w-[111.33px] rounded-[40px] bg-[#4360EC] text-[12px] font-bold text-white md:h-[30px] md:w-[127px]"
            onClick={moveToPriceGuide}
          >
            {' '}
            지금 시작하기
          </button>
        </div>
        <div className="flex w-[150px] flex-col items-end md:w-[195px]">
          <p className="mb-2 rounded-[10px] bg-[#FFF6E6] px-3 py-1 text-center text-[12px] font-bold">
            미션 시작 전
          </p>
          <p className="mb-1 text-[14px] font-bold md:text-base">
            이번 라운드 럭키 드로우
          </p>
          <p
            className="mb-4 flex h-[41px] w-[145px] items-center justify-center rounded-[6px] bg-cover bg-center text-[20px] font-bold text-white"
            style={{
              backgroundImage: "url('assets/img/blue_balance.png')",
            }}
          >
            ???????
          </p>

          <p
            className="cursor-pointer text-[12px] font-bold text-[#FF8800]"
            onClick={() => {
              setCouponTooltipStatus((prev) => !prev)
            }}
          >
            {' '}
            럭키드로우 미션 자세히 보기 {`>`}
          </p>
        </div>
        <CouponToolitip
          couponTooltipStatus={couponTooltipStatus}
          setCouponTooltipStatus={setCouponTooltipStatus}
        />
      </div>
    </>
  )
}
